import dashboard_icon from '../../assets/img/dashboard.svg';
import help_icon from '../../assets/img/help-white.svg';
import groups_icon from '../../assets/img/user-groups.svg';
import video_icon from '../../assets/img/video-white.svg';
import logout_icon from '../../assets/img/logout.svg';
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import FeedbackBlock from "../blocks/FeedbackBlock";
import { t } from "i18next";

interface NavigationProps {
    closeMobileMenu: () => void;
}

export default function Navigation({ closeMobileMenu }: NavigationProps) {
    const navigate = useNavigate();

    const handleLogout = (event: any) => {
        event.preventDefault();
        localStorage.setItem('userId', '');
        localStorage.setItem('userRole', '');
        localStorage.setItem('isAdmin', '');
        closeMobileMenu();
        navigate('/');
    }

    const handleLinkClick = () => {
        closeMobileMenu();
    }

    return (
        <div className="navigation">
            <button className="close-mobile-btn" onClick={closeMobileMenu} aria-label="Close menu">
                <i className="bi bi-x-lg"></i>
            </button>
            <ul className="nav-list primary-group">
                <li>
                    <Link className="nav-link active" to="/dashboard" title={t("Dashboard")} onClick={handleLinkClick}>
                        <img src={dashboard_icon} alt="Dashboard"/>
                        <span>{t("Dashboard")}</span>
                    </Link>
                </li>
                <li>
                    <Link className="nav-link user-groups" to="/users-groups" title={t("User groups")} onClick={handleLinkClick}>
                        <img src={groups_icon} alt="User groups"/>
                        <span>{t("User groups")}</span>
                    </Link>
                </li>
                <li>
                    <Link className="nav-link" to="/video-tutorials" title={t("Video tutorials")} onClick={handleLinkClick}>
                        <img src={video_icon} alt="Video tutorials"/>
                        <span>{t("Video tutorials")}</span>
                    </Link>
                </li>
                <li>
                    <Link className="nav-link" to="/help" title={t("Help")} onClick={handleLinkClick}>
                        <img src={help_icon} alt="Help"/>
                        <span>{t("Help")}</span>
                    </Link>
                </li>
            </ul>
            <ul className="nav-list logout-group">
                <li>
                    <a href="#" onClick={handleLogout} className="nav-link logout" title={t("Log out")}>
                        <img src={logout_icon} alt="Log out"/>
                        <span>{t("Log out")}</span>
                    </a>
                </li>
            </ul>
        </div>
    );
}